import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { format } from 'date-fns';

type NumericStrings = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

export interface EngineiusHomepageLinkDTO {
  text: string;
  url: string;
}

export enum KeyMetricType {
  MovementsCompleted,
  GrossProfitAfterInsurance,
  PercentageOnTime,
  PercentageAutoDeployed,
}

export class KeyMetricValue {
  actualValue: number = 0;
  targetValue: number = 0;
  periodLabel: string = '';
}

export class KeyMetricDTO {
  previousPeriod: KeyMetricValue;
  currentPeriod: KeyMetricValue;
  nextPeriod: KeyMetricValue;
}

export type KeyMetricResult = Record<keyof KeyMetricType, KeyMetricDTO>;

@Injectable({ providedIn: 'root' })
export class EngineiusHomepageService {
  url = '/api/EngineiusHomepage';

  constructor(private http: HttpClient, private handlersFactory: HttpResponsesHandlersFactory) {}

  getKeyMetrics(startDate: Date, endDate: Date): Promise<KeyMetricResult> {
    return this.http
      .get<KeyMetricResult>(`${this.url}/KeyMetrics`, {
        params: {
          startDate: format(startDate, 'yyyy-MM-dd HH:mm:ss'),
          endDate: format(endDate, 'yyyy-MM-dd HH:mm:ss'),
        },
      })
      .toPromise();
  }

  getWelcomeLinks(): Promise<EngineiusHomepageLinkDTO[]> {
    return this.http.get<EngineiusHomepageLinkDTO[]>(`${this.url}/Links`).toPromise();
  }
}
